module.exports = __webpack_public_path__ + "media/images/massage/mathieu@3x-5de378321ee1c07240c2fbddb9258e37.jpg";